/* eslint-disable max-len */
import { $Q } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';

/**
 * Validate if the product with discount exist
 * and validate the if the product is added
 */
export const updateProductDiscount = (str) => {
  const productId = $Q('.productdiscountid-js');

  if (productId) {
    productId.outerHTML = $Q(
      '.productdiscountid-js',
      stringToHTML(str)
    ).outerHTML;
  }
};
